/*
  Secrets of Amber — product page bundle offer.
  Same storage format as collection-bundle.js: ecomify-bundle-v2.

  Le bloc est DYNAMIQUE : il additionne
    - les modèles déjà dans le panier (ajoutés par n'importe quel bouton :
      fiche produit, ajout rapide en collection, upsell, page pack…)
    - les modèles choisis dans le pack et pas encore ajoutés au panier
  La popup « Mon pack » LISTE tous ces modèles (panier + sélection).
  Le récapitulatif (prix, économie) porte sur l'ensemble : panier + pack.
  Il se met à jour à chaque changement du panier (événement updated.ecomify.cart).
  La protection de colis n'est jamais comptée.
*/
(() => {
  const STORAGE_KEY = 'ecomify-bundle-v2'

  let cartState = { count: 0, originalTotal: 0, variantQty: {}, items: [] }

  const getRoots = () => Array.from(document.querySelectorAll('[data-soa-pdp-bundle]'))

  const readContents = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
      return Array.isArray(value) ? value : []
    } catch (e) {
      return []
    }
  }

  const writeContents = (contents) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(contents))
    window.dispatchEvent(new CustomEvent('soa:bundle-updated'))
  }

  const parseTiers = (root) =>
    String(root.dataset.tiers || '2:5,3:10')
      .split(',')
      .map(item => {
        const [qty, discount] = item.split(':')
        return { qty: Number(String(qty).trim()), discount: Number(String(discount).trim()) }
      })
      .filter(t => Number.isFinite(t.qty) && Number.isFinite(t.discount))
      .sort((a, b) => a.qty - b.qty)

  const plural = (n, word) => `${n} ${word}${n > 1 ? 's' : ''}`

  const escapeHtml = value =>
    String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')

  const sizedImage = url => {
    if (!url) return ''
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160'
  }

  // ---------- Panier ----------
  const protectionVariantId = () => {
    const el = document.querySelector('[data-shipping-protection-variant-id]')
    return el ? Number(el.dataset.shippingProtectionVariantId) : 0
  }

  const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      const cart = await res.json()
      const protectId = protectionVariantId()
      const variantQty = {}
      const items = []
      let count = 0
      let originalTotal = 0
      ;(cart.items || []).forEach(item => {
        if (protectId && Number(item.variant_id) === protectId) return
        if (String(item.product_type || '').toLowerCase().includes('protection')) return
        if (String(item.handle || '').includes('protection-de-colis')) return
        const qty = Number(item.quantity || 0)
        count += qty
        originalTotal += Number(item.original_line_price ?? (item.original_price * qty) ?? 0)
        variantQty[item.variant_id] = (variantQty[item.variant_id] || 0) + qty
        items.push({
          variant_id: item.variant_id,
          product_title: item.product_title || item.title || '',
          variant_title: item.variant_title || '',
          variant_image: item.image || (item.featured_image && item.featured_image.url) || '',
          variant_price: Number(item.original_price ?? item.price ?? 0),
          quantity: qty
        })
      })
      cartState = { count, originalTotal, variantQty, items }
    } catch (e) {
      cartState = { count: 0, originalTotal: 0, variantQty: {}, items: [] }
    }
    renderAll()
  }

  // Modèles du pack pas encore présents dans le panier
  const pendingPack = contents => contents.filter(item => !cartState.variantQty[item.variant_id])

  const getTotalCount = contents =>
    cartState.count + pendingPack(contents).reduce((sum, item) => sum + Number(item.quantity || 1), 0)

  const getReachedTier = (tiers, count) => tiers.filter(t => count >= t.qty).pop()
  const getNextTier = (tiers, count) => tiers.find(t => count < t.qty)

  const formatMoney = cents => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(Math.round(Number(cents) || 0))
    }
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
      .format((Number(cents) || 0) / 100)
  }

  const getModal = root => {
    const id = root.dataset.modalId
    return id ? document.getElementById(id) : null
  }

  const getBootstrap = () => {
    if (window.bootstrap) return window.bootstrap
    if (typeof bootstrap !== 'undefined') return bootstrap
    return null
  }

  const currentVariant = root => {
    const form = root.closest('form')
    const input = form ? form.querySelector('[name="id"]') : null
    const variantId = Number(input?.value || root.dataset.defaultVariantId)

    let variants = []
    try {
      variants = JSON.parse(form?.dataset.variants || '[]')
    } catch (e) {}

    const variant = variants.find(v => Number(v.id) === variantId) || {}
    const image =
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src ||
      root.dataset.defaultImage ||
      ''

    return {
      variant_id: variantId,
      variant_title: variant.title || root.dataset.defaultVariantTitle || 'Default Title',
      variant_price: Number(variant.price ?? root.dataset.defaultPrice ?? 0),
      variant_image: image
    }
  }

  const openModal = root => {
    const modal = getModal(root)
    const bs = getBootstrap()
    if (!modal || !bs?.Modal) return
    bs.Modal.getOrCreateInstance(modal).show()
  }

  const openCartDrawer = root => {
    const bs = getBootstrap()
    const modal = getModal(root)
    if (modal && bs?.Modal) bs.Modal.getOrCreateInstance(modal).hide()
    const cart = document.querySelector('#offcanvas-cart')
    if (cart && bs?.Offcanvas) {
      window.setTimeout(() => bs.Offcanvas.getOrCreateInstance(cart).show(), 250)
    } else {
      window.location.href = '/cart'
    }
  }

  const addOrUpdateCurrent = root => {
    const productId = Number(root.dataset.productId)
    const selected = currentVariant(root)
    let contents = readContents()
    const existing = contents.find(item => Number(item.product_id) === productId)
    let action = 'added'

    if (existing && Number(existing.variant_id) === Number(selected.variant_id)) {
      contents = contents.filter(item => Number(item.product_id) !== productId)
      action = 'removed'
    } else {
      if (existing) action = 'updated'
      contents = contents.filter(item => Number(item.product_id) !== productId)
      contents.push({
        product_id: productId,
        product_title: root.dataset.productTitle,
        variant_id: selected.variant_id,
        variant_title: selected.variant_title,
        variant_price: selected.variant_price,
        variant_image: selected.variant_image,
        quantity: 1
      })
    }

    writeContents(contents)

    if (action !== 'removed') {
      window.setTimeout(() => openModal(root), 80)
    }
  }

  const removeVariant = variantId => {
    const contents = readContents().filter(item => Number(item.variant_id) !== Number(variantId))
    writeContents(contents)
  }

  const progressMessage = (tiers, count, firstLine, withCartNote) => {
    const reached = getReachedTier(tiers, count)
    const next = getNextTier(tiers, count)
    const inCart = cartState.count
    const cartNote = withCartNote && inCart > 0
      ? `<span class="soa-pdp-bundle__cart-note">🛒 Déjà ${plural(inCart, 'modèle')} dans votre panier</span><br>`
      : ''

    if (next) {
      const remaining = next.qty - count
      if (count === 0 && firstLine) {
        return `Choisissez <strong>${next.qty} modèles</strong> et profitez de <strong>-${next.discount}%</strong>.`
      }
      const already = reached ? `Vous profitez de <strong>-${reached.discount}%</strong> 🎁 ` : ''
      return `${cartNote}${already}Encore <strong>${plural(remaining, 'modèle')}</strong> pour débloquer <strong>-${next.discount}%</strong>.`
    }
    return `${cartNote}Bravo ! Votre sélection bénéficie de <strong>-${reached ? reached.discount : 0}%</strong> 🎁`
  }

  const itemRow = (item, inCart) => {
    const variant = String(item.variant_title || '')
    const showVariant = variant && !variant.includes('Default Title')
    const qty = Number(item.quantity || 1)
    const qtyBadge = qty > 1 ? ` <span class="small fw-normal">× ${qty}</span>` : ''
    const status = inCart
      ? ' <span class="text-success small fw-normal">· ✓ dans votre panier</span>'
      : ' <span class="small fw-normal" style="color:#6069AB">· à ajouter</span>'
    const action = inCart
      ? ''
      : `<button class="soa-bundle-modal__remove" type="button" data-soa-remove-variant="${item.variant_id}" aria-label="Retirer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>`
    return `
      <div class="soa-bundle-modal__item">
        <img src="${escapeHtml(sizedImage(item.variant_image))}" alt="" loading="lazy">
        <div>
          <p class="soa-bundle-modal__item-title">${escapeHtml(item.product_title)}${qtyBadge}</p>
          ${showVariant ? `<p class="soa-bundle-modal__item-variant">${escapeHtml(variant)}</p>` : ''}
          <div class="soa-bundle-modal__item-price">${formatMoney(item.variant_price)}${status}</div>
        </div>
        ${action}
      </div>
    `
  }

  const renderModal = (root, contents, tiers, count) => {
    const modal = getModal(root)
    if (!modal) return

    const empty = modal.querySelector('[data-soa-bundle-empty]')
    const filled = modal.querySelector('[data-soa-bundle-filled]')
    const list = modal.querySelector('[data-soa-bundle-list]')
    const cartBtn = modal.querySelector('[data-soa-bundle-cart]')
    const minQty = tiers[0]?.qty || 2
    const pending = pendingPack(contents)

    if (!contents.length && cartState.count === 0) {
      empty?.removeAttribute('hidden')
      filled?.setAttribute('hidden', 'hidden')
      if (cartBtn) cartBtn.disabled = true
      return
    }

    empty?.setAttribute('hidden', 'hidden')
    filled?.removeAttribute('hidden')

    if (list) {
      // 1. Tous les modèles déjà au panier (quel que soit le bouton utilisé)
      // 2. Les modèles choisis dans le pack, pas encore au panier
      const html =
        cartState.items.map(item => itemRow(item, true)).join('') +
        pending.map(item => itemRow(item, false)).join('')
      list.innerHTML = html
    }

    modal.querySelectorAll('[data-soa-remove-variant]').forEach(btn => {
      btn.onclick = () => removeVariant(btn.dataset.soaRemoveVariant)
    })

    // Récapitulatif sur l'ensemble : panier + modèles du pack pas encore ajoutés
    const pendingTotal = pending.reduce((sum, item) => sum + Number(item.variant_price || 0) * Number(item.quantity || 1), 0)
    const fullTotal = cartState.originalTotal + pendingTotal
    const reached = getReachedTier(tiers, count)
    const discount = reached?.discount || 0
    const saving = Math.round(fullTotal * discount / 100)
    const maxQty = tiers[tiers.length - 1]?.qty || minQty
    const width = Math.min(100, Math.round((count / maxQty) * 100))

    const modalProgress = modal.querySelector('[data-soa-modal-progress]')
    if (modalProgress) modalProgress.style.width = width + '%'

    const modalMessage = modal.querySelector('[data-soa-modal-message]')
    if (modalMessage) modalMessage.innerHTML = progressMessage(tiers, count, false, false)

    const priceEl = modal.querySelector('[data-soa-modal-price]')
    if (priceEl) {
      priceEl.innerHTML = reached && fullTotal > 0
        ? `<s class="text-muted fw-normal me-1">${formatMoney(fullTotal)}</s> ${formatMoney(fullTotal - saving)}`
        : formatMoney(fullTotal)
    }

    const savingEl = modal.querySelector('[data-soa-modal-saving]')
    if (savingEl) {
      savingEl.textContent = reached && fullTotal > 0 ? `${formatMoney(saving)} (-${discount}%)` : formatMoney(0)
    }

    if (cartBtn) {
      if (!pending.length && cartState.count > 0) {
        cartBtn.disabled = false
        cartBtn.textContent = 'Voir mon panier'
        cartBtn.dataset.mode = 'cart'
      } else if (count < minQty) {
        cartBtn.disabled = true
        cartBtn.textContent = `Encore ${plural(minQty - count, 'modèle')}`
        cartBtn.dataset.mode = 'add'
      } else {
        cartBtn.disabled = false
        cartBtn.textContent = root.dataset.textCart
        cartBtn.dataset.mode = 'add'
      }
    }
  }

  const renderRoot = root => {
    const contents = readContents()
    const tiers = parseTiers(root)
    if (!tiers.length) return

    const count = getTotalCount(contents)
    const maxQty = tiers[tiers.length - 1].qty
    const next = getNextTier(tiers, count)
    const width = Math.min(100, Math.round((count / maxQty) * 100))

    root.querySelectorAll('[data-soa-bundle-count]').forEach(el => {
      el.textContent = String(count)
    })

    const progress = root.querySelector('[data-soa-bundle-progress]')
    if (progress) progress.style.width = width + '%'

    const message = root.querySelector('[data-soa-bundle-message]')
    if (message) message.innerHTML = progressMessage(tiers, count, true, true)

    root.querySelectorAll('[data-soa-tier]').forEach(tierEl => {
      const threshold = Number(tierEl.dataset.threshold)
      tierEl.classList.toggle('is-reached', count >= threshold)
      tierEl.classList.toggle('is-next', Boolean(next && threshold === next.qty))
    })

    const productId = Number(root.dataset.productId)
    const selected = currentVariant(root)
    const existing = contents.find(item => Number(item.product_id) === productId)
    const toggle = root.querySelector('[data-soa-bundle-toggle]')

    if (toggle) {
      toggle.classList.remove('is-added')
      if (cartState.variantQty[selected.variant_id] && !existing) {
        toggle.textContent = '✓ Déjà dans votre panier'
        toggle.classList.add('is-added')
      } else if (!existing) {
        toggle.textContent = root.dataset.textAdd
      } else if (Number(existing.variant_id) === Number(selected.variant_id)) {
        toggle.textContent = root.dataset.textAdded
        toggle.classList.add('is-added')
      } else {
        toggle.textContent = root.dataset.textUpdate
      }
    }

    renderModal(root, contents, tiers, count)
  }

  const renderAll = () => getRoots().forEach(renderRoot)

  const addPackToCart = async root => {
    const tiers = parseTiers(root)
    const contents = readContents()
    const pending = pendingPack(contents)
    const count = getTotalCount(contents)
    const minQty = tiers[0]?.qty || 2
    if (count < minQty || !pending.length) return

    const modal = getModal(root)
    const btn = modal?.querySelector('[data-soa-bundle-cart]')
    const originalText = btn?.textContent || root.dataset.textCart

    if (btn) {
      btn.disabled = true
      btn.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>'
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: pending.map(item => ({
            id: item.variant_id,
            quantity: Number(item.quantity || 1)
          }))
        })
      })

      if (!response.ok) {
        if (typeof window.refreshCartContents === 'function') {
          await window.refreshCartContents(response)
        }
        throw new Error('Cart error')
      }

      localStorage.removeItem(STORAGE_KEY)

      const bs = getBootstrap()
      if (modal && bs?.Modal) {
        bs.Modal.getOrCreateInstance(modal).hide()
      }

      if (typeof window.refreshCartContents === 'function') {
        await window.refreshCartContents(response)
      } else {
        fetchCart()
      }

      const cart = document.querySelector('#offcanvas-cart')
      if (cart && bs?.Offcanvas) {
        bs.Offcanvas.getOrCreateInstance(cart).show()
      }
    } catch (e) {
      if (btn) {
        btn.disabled = false
        btn.textContent = originalText
      }
    }
  }

  const initRoot = root => {
    if (root.dataset.soaBundleInit === '1') return
    root.dataset.soaBundleInit = '1'

    const modal = getModal(root)

    // Bootstrap modals are more reliable as direct children of body.
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal)
    }

    root.querySelector('[data-soa-bundle-toggle]')?.addEventListener('click', () => addOrUpdateCurrent(root))
    modal?.querySelector('[data-soa-bundle-cart]')?.addEventListener('click', (e) => {
      if (e.currentTarget.dataset.mode === 'cart') {
        openCartDrawer(root)
      } else {
        addPackToCart(root)
      }
    })

    // Toujours repartir du panier réel à l'ouverture de la popup
    modal?.addEventListener('show.bs.modal', fetchCart)

    const form = root.closest('form')
    if (form) {
      form.addEventListener('change', () => {
        window.setTimeout(() => renderRoot(root), 80)
      })
    }

    renderRoot(root)
  }

  const init = () => {
    getRoots().forEach(initRoot)
    fetchCart()
  }

  document.addEventListener('DOMContentLoaded', init)
  if (document.readyState !== 'loading') init()

  // Mise à jour dès que le panier change (bouton Ajouter au panier, ajout rapide, tiroir, upsell…)
  window.addEventListener('updated.ecomify.cart', fetchCart)
  window.addEventListener('pageshow', fetchCart)
  window.addEventListener('soa:bundle-updated', renderAll)
  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) renderAll()
  })
})()
